import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/strategy/$blueprintId")({
  loader: ({ context, params }) => {
    void import("~/features/template/template-route").then(
      ({ preloadTemplateRoute }) => {
        void preloadTemplateRoute(context, params.blueprintId);
      },
    );
  },
});
